/**
 * created by xcc
 * 阵地安全管理
 *
 */
import React from 'react';
import BaseComponent from '../../../../base/BaseComponent'
import PageTemplate from "../../components/pageTemplate/PageTemplate";
import TabsTemplate from "../../components/TabsTemplate/TabsTemplate";
import {
    getColorByHandleType,
    getColorByRemindType, getColorByRiskLevel, getColorBySecurityType,
    getPmsListBtn,
    handleStatus
} from "./safetyManageConfig";
import {Button, Checkbox} from "antd";
import SearchTemplate from "../../components/searchTemplate/SearchTemplate";
import InteractBtn from "./components/interactBtn";
import TableTemplate from "../../components/TableTemplate/TableTemplate";
import PaginationTemplate from "../../components/PaginationTemplate/PaginationTemplate";
import {getAllPositionTypeData} from "../../../newMediaMatrix/actions/actions";
import {formatTime, letterUUID} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import {message} from "../../../../utils/message";
import Detail from "./components/detail";
import Remark from "./components/remark";
import Preview from "./components/contentView/preView";
import {generateColumns, getMaxWidth} from "../../../newMediaMatrix/components/utils";
import noImg from "../../../positionManage/images/noImg.png";
import {CUSTOM_CONFIG} from "../../../../config/customConfig";

export default class PositionSafetyManage extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            params: {
                page: 1,
                size: 10
            },
            count: 0,
            tabKey: "",
            gradeData: [],
            typeData: [],
            mainUnitData: [],
            listData: [],
            moreScreen: false
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getGradeData();
        this.getAllPositionTypeData();
        this.getMainUnitData();
        this.getListData();
    }

    getGradeData() {
        this.request({
            url: '/cm-sites-media-consumer/position/overview/getPositionTypeGrade',
            body: {},
            callBack: (data) => {
                let gradeData = [];
                if (data && data.length) {
                    gradeData = data.map(item => {
                        return {key: item.gradeKey, name: item.grade}
                    })
                }
                this.setState({
                    gradeData
                });
            },
            errorCallBack: (e) => {
            },
        })
    }

    getAllPositionTypeData() {
        getAllPositionTypeData({}, (data) => {
            let typeData = [];
            if (data && data.length) {
                typeData = data.map(item => {
                    return {
                        ...item,
                        key: item.id
                    }
                })
            }
            this.setState({
                typeData
            })
        })
    }

    getMainUnitData() {
        this.request({
            url: "/cm-sites-sys/dept/getDeptAndSon",
            body: ["0"],
            method: "post",
            contentType: "json",
            callBack: (data) => {
                let mainUnitData = [];
                if (data && data.length) {
                    mainUnitData = data.map(item => {
                        return {
                            ...item,
                            key: item.id
                        }
                    })
                }
                this.setState({
                    mainUnitData
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    getListData() {
        this.request({
            url: "/cm-sites-media-consumer/safety/management/list",
            body: this.state.params,
            callBack: (data) => {
                let listData = [];
                let count = 0;
                if (data && data.data && data.data.length) {
                    count = data.count;
                    listData = data.data.map(item => {
                        return {
                            ...item,
                            checked: false
                        }
                    });
                }
                this.setState({
                    listData,
                    count,
                    batchRemindStatus: false,
                    batchIgnoreStatus: false
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    refreshList(reSetPage = true) {
        if (reSetPage) {
            this.state.params.page = 1;
            this.state.params.size = 10;
        }
        this.state.params.disposeStatus = this.state.tabKey
        this.getListData()
    }

    renderTabs() {
        let {tabKey = ""} = this.state;
        return (
            <div className={"safetyManageTabs"} style={{
                height: 55,
                lineHeight: '55px',
                paddingLeft: 32,
                borderBottom: '1px solid #ebebeb',
                backgroundColor: "#fff",
                borderRadius: "5px 5px 0 0",
                margin: "15px 15px 0 15px"
            }}>
                <TabsTemplate
                    // key={"handleStatus" + tabKey}
                    tabChange={(val) => {
                        this.state.tabKey = val;
                        this.onChange("disposeStatus", val);
                    }}
                    nav={handleStatus}
                    tabKey={tabKey}
                    onResize={(offsetHeight) => {
                    }}
                />
                <style>{`
                    .safetyManageTabs .ant-tabs-bar{border-bottom:none !important}
                    .safetyManageTabs .ant-tabs-nav { height: 55px;line-height:35px}
                    }`}</style>
            </div>
        )
    }

    onChange = (key, val) => {
        if (val || val === 0) {
            this.state.params[key] = val;
        } else {
            delete this.state.params[key];
        }
        this.refreshList()
    };

    obj = {
        "all": ""
    }

    sysConfigInfo = [
        {
            key: "sensitive",
            name: "敏感信息",
            child: ["历任领导人相关表述", "台湾相关表述", "领导讲话诗词及引用", "机构名称", "国家、民族以及政体等相关表述", "禁用词", "中国共产党相关表述", "党员思想教育相关表述", "时政相关表述", "国际关系等相关表述", "行政区域名称等相关表述", "国家机关单位名称等相关表述", "党政领导职务称谓等表述", "国家现任领导人及其重点思想、语录等相关表述"]
        },
        {
            key: "privacy",
            name: "隐私信息",
            child: ["身份证号", "手机号", "银行卡"]
        },
        {
            key: "corrupt_official",
            name: "落马官员",
            child: ["中管干部", "中央一级党和国家机关、国企和金融单位干部", "省管干部"]
        },
        {
            key: "fallenOfficial",
            name: "落马官员",
            child: ["中管干部", "中央一级党和国家机关、国企和金融单位干部", "省管干部"]
        },
        {
            key: "blacklink",
            name: "非法链接",
            child:[]
        },
        {
            key: "custom_check",
            name: "自定义词",
            child:[]
        },
    ]

    sysConfig = this.sysConfigGetValueByKey("safety.manage.security.type", JSON.stringify(this.sysConfigInfo));

    riskLevelList = [{key: "high", name: "高危"}, {key: "middle", name: "中危"}, {key: "low", name: "低危"}]

    selectList() {
        let sysConfig = JSON.parse(this.sysConfig);
        const securityType = sysConfig ? sysConfig.map(item => ({
            key: item.key,
            name: item.name,
            child: item.child.map(subItem => ({
                key: subItem.trim(),
                name: subItem.trim()
            }))
        })) : [];
        const category = this.state.params.securityType && securityType ? securityType.find(item => item.key === this.state.params.securityType)?.child : [];
        let baseColumns = [
            {
                type: 2,
                component: 'select',
                labelName: "媒体平台",
                placeholder: '媒体平台',
                labelCode: 'positionTypeId',
                showIcon: true,
                value: this.state.params.positionTypeId || undefined,
                selectValues: this.state.typeData,
                onChange: (val) => {
                    this.onChange('positionTypeId', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            },
            {
                type: 2,
                component: 'select',
                labelName: "主责单位",
                placeholder: '主责单位',
                labelCode: 'deptId',
                value: this.state.params.deptId || undefined,
                selectValues: this.state.mainUnitData,
                onChange: (val) => {
                    this.onChange('deptId', val)
                },
                styleOut: {
                    display: this.permissionCheck("pms:positionManage:all") ? "inline-block" : "none",
                    width: 220,
                    paddingTop: 0
                },
                style: {
                    width: "100%",
                    borderRadius: 5,
                }
            },
            {
                type: 2,
                component: 'select',
                labelName: "提醒状态",
                placeholder: '提醒状态',
                labelCode: 'remindStatus',
                value: (this.state.params.remindStatus || this.state.params.remindStatus === 0) ? this.state.params.remindStatus : undefined,
                selectValues: [
                    {key: 0, name: "已忽略"},
                    {key: 1, name: "未提醒"},
                    {key: 2, name: "已提醒"}
                ],
                onChange: (val) => {
                    this.onChange('remindStatus', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            },
            {
                type: 2,
                component: 'select',
                labelName: "风险类型",
                placeholder: '风险类型',
                labelCode: 'remindStatus',
                value: this.state.params.securityType || undefined,
                selectValues: securityType,
                onChange: (val) => {
                    this.state.params.category = "";
                    this.onChange('securityType', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            },
            {
                type: 2,
                component: 'select',
                labelName: "风险等级",
                placeholder: '风险等级',
                labelCode: 'riskLevel',
                value: (this.state.params.riskLevel || this.state.params.riskLevel === 0) ? this.state.params.riskLevel : undefined,
                selectValues: this.riskLevelList,
                onChange: (val) => {
                    this.onChange('riskLevel', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            },
            {
                type: 1,
                component: <Button onClick={() => {
                    this.state.params = {
                        page: 1,
                        size: 10
                    };
                    this.refreshList();
                }}>重置</Button>,
                styleOut: {
                    paddingTop: 0
                },
            }
        ];
        const dynamicColumns = [
            {
                type: 2,
                component: 'select',
                labelName: "敏感信息",
                placeholder: securityType.map(item => item.key === this.state.params.securityType ? item.name : ""),
                labelCode: 'category',
                value: this.state.params.category || undefined,
                selectValues: category,
                onChange: (val) => {
                    this.onChange('category', val)
                },
                checkFunction: () => {
                    return this.state.params.securityType;
                },
                position: 5,
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 290,
                    borderRadius: 5,
                }
            },
        ];
        if(this.state.gradeData && this.state.gradeData.length) {
            baseColumns.unshift({
                type: 2,
                component: 'select',
                labelName: "账号等级",
                placeholder: '账号等级',
                labelCode: 'positionTypeId',
                value: this.state.params.grade || undefined,
                selectValues: this.state.gradeData,
                onChange: (val) => {
                    this.onChange('grade', val)
                },
                styleOut: {
                    paddingTop: 0
                },
                style: {
                    width: 160,
                    borderRadius: 5,
                }
            });
        }
        return [generateColumns(baseColumns, dynamicColumns)]
    }

    confirm(status, statusName) {
        let ids = this.state.listData.filter(item => item.checked).map(i => i.id);
        if (!ids.length) {
            message.warn(`请选择${statusName}的数据！`);
            return;
        }
        let body = {ids, status}
        this.request({
            url: '/cm-sites-media-consumer/safety/management/batchUpdateStatus',
            body: body,
            method: "post",
            callBack: (data) => {
                if (data) {
                    message.success(`${statusName}成功`);
                    this.getListData();
                } else {
                    message.warn(`${statusName}失败`);
                }
            },
            errorCallBack: (e) => {
            },
        })
    }

    toggleBatchRemindStatus = (batchRemindStatus) => {
        if (batchRemindStatus) {
            this.state.listData.forEach(item => {
                item.checked = item.disposeStatus === 1 || item.disposeStatus === 4;
            });
        } else {
            this.state.listData.forEach(item => {
                item.checked = false
            });
        }

        this.setState({
            batchRemindStatus,
            batchIgnoreStatus: false
        })
    }

    toggleBatchIgnoreStatus = (batchIgnoreStatus) => {
        if (batchIgnoreStatus) {
            this.state.listData.forEach(item => {
                item.checked = item.disposeStatus === 1;
            });
        } else {
            this.state.listData.forEach(item => {
                item.checked = false
            });
        }

        this.setState({
            batchIgnoreStatus,
            batchRemindStatus: false
        })
    }

    exportTable() {
        if (!this.state.listData?.length) {
            message.warning('没有可导出的数据')
            return false
        }
        let ids = this.state.listData.map(item => item.id);
        this.request({
            url: "/cm-sites-media-consumer/safety/management/outputList",
            body:this.state.params,
            method: "downloadPost",
            callBack: (res) => {
                if (res) {
                    message.success("导出成功");
                }
            },
        })
    }

    operateList() {
        let {
            batchRemindStatus,
            batchIgnoreStatus
        } = this.state;
        return [
            [
                {
                    type: 1,
                    component: <Button onClick={() => {
                        this.exportTable();
                    }}>导出表格</Button>,
                    styleOut: {}
                },
                {
                    type: 1,
                    component: <InteractBtn key={"batchRemind"}
                                            showName={"批量提醒"}
                                            okName={"确定提醒"}
                                            status={batchRemindStatus}
                                            toggleStatus={this.toggleBatchRemindStatus}
                                            confirm={() => {
                                                this.confirm(-1, "批量提醒")
                                            }}
                    />,
                    styleOut: {display: batchIgnoreStatus ? "none" : "block"}
                },
                {
                    type: 1,
                    component: <InteractBtn key={"batchIgnore"}
                                            showName={"批量忽略"}
                                            okName={"确定忽略"}
                                            status={batchIgnoreStatus}
                                            toggleStatus={this.toggleBatchIgnoreStatus}
                                            confirm={() => {
                                                this.confirm(0, "批量忽略")
                                            }}
                    />,
                    styleOut: {display: batchRemindStatus ? "none" : "block"}
                }
            ]
        ]
    }

    operateMore() {
        return [
            [
                {
                    type: 2,
                    component: 'search',
                    placeholder: '请输入稿件标题关键词',
                    labelCode: 'keyWord',
                    value: this.state.params.keyWord,
                    onSearch: (val) => {
                        this.state.params.keyWord = val;
                        this.refreshList();
                    },
                    onChange: (val) => {
                        this.state.params.keyWord = val;
                        this.setState({})
                    },
                    styleOut: {},
                },
                {
                    type: 1,
                    component: <Button onClick={() => {
                        this.setState({
                            moreScreen: !this.state.moreScreen
                        })
                    }}>{this.state.moreScreen ? "收起筛选" : "更多筛选"}</Button>,
                }
            ]
        ]
    }

    renderSearch() {
        return (
            <SearchTemplate
                key={"selectSearch"}
                btnList={this.selectList()}
                onResize={(offsetHeight) => {
                    if (this.searchHeight != offsetHeight) {
                        this.searchHeight = offsetHeight;
                        this.calculateTableHeight(this.searchHeight)
                        this.setState({});
                    }
                }}
                ref={(ref) => {
                    this.search = ref;
                }}
            />
        )
    }

    calculateTableHeight(searchHeight) {
        const otherHeight = searchHeight + this.pageMargin * 2 + this.tabsHeight + this.paginationHeight + this.screenHeight + this.topMenuHeight + this.extraHeight;
        return `calc(100vh - ${otherHeight}px)`;
    }

    renderOperate() {
        return (
            <SearchTemplate
                key={"operateSearch"}
                btnList={this.operateList()}
                onResize={(offsetHeight) => {
                    if (this.screenHeight != offsetHeight) {
                        this.screenHeight = offsetHeight;
                        this.setState({});
                    }
                }}
                ref={(ref) => {
                    this.operate = ref;
                }}
            />
        )
    }

    renderMore() {
        return (
            <SearchTemplate
                key={"operateMoreKey"}
                btnList={this.operateMore()}
                onResize={(offsetHeight) => {
                    if (this.screenHeight != offsetHeight) {
                        this.screenHeight = offsetHeight;
                        this.setState({});
                    }
                }}
                ref={(ref) => {
                    this.more = ref;
                }}
            />
        )
    }

    getColumns() {
        return (
            [
                {
                    title: "稿件标题",
                    dataIndex: "title",
                    key: "title",
                    width: 400,
                    ellipsis: true,
                    render: (text, record, index) => {
                        return <div onClick={() => {
                            this.preview.openModal(record);
                        }} style={{
                            color: "#0050B3",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            cursor: "pointer"
                        }}>{text ? text : ''}</div>
                    }
                },
                {
                    title: "所属账号",
                    dataIndex: "positionName",
                    key: "positionName",
                    width: 250,
                    ellipsis: true,
                    render: (text, record, index) => {
                        let typeItem = this.state.typeData.length && this.state.typeData.find(item => item.id === record.positionTypeId);
                        return <div title={text}
                                    style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                            <img style={{
                                width: 16,
                                height: 16,
                                objectFit: "cover",
                                verticalAlign: "text-bottom",
                                marginRight: 5
                            }} src={typeItem?.logo || noImg}/>{text}
                        </div>
                    }
                },
                {
                    title: "提醒状态",
                    dataIndex: "remindStatusName",
                    key: "remindStatusName",
                    ellipsis: true,
                    width: 150,
                    render: (text, record, index) => {
                        let remindCount = null;
                        if (record.remindStatus === 2 && record.remindCount) {
                            remindCount = <span><span style={{
                                color: "rgba(255, 0, 0, 0.7)",
                                fontSize: 16,
                                padding: "0 2px"
                            }}>{record.remindCount}</span>次</span>;
                        }
                        return <div>
                            <span style={{
                                display: "inline-block",
                                marginRight: 5,
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: getColorByRemindType(record.remindStatus)
                            }}></span>{text ? text : ''}{remindCount}
                        </div>
                    }
                },
                {
                    title: "处理状态",
                    dataIndex: "disposeStatusName",
                    key: "disposeStatusName",
                    ellipsis: true,
                    width: 150,
                    render: (text, record, index) => {
                        return <div>
                            <span style={{
                                display: "inline-block",
                                marginRight: 5,
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: getColorByHandleType(record.disposeStatus)
                            }}></span>{text ? text : ''}
                        </div>
                    }
                },
                {
                    title: "风险等级",
                    dataIndex: "riskLevel",
                    key: "riskLevel",
                    ellipsis: true,
                    render: (text, record, index) => {
                        return <div style={{color: getColorByRiskLevel(text)}}>
                            {text ? this.riskLevelList.map(item => item.key === text ? item.name : '') : ''}
                        </div>
                    }
                },
                {
                    title: "风险类型",
                    dataIndex: "securityTypeList",
                    key: "securityTypeList",
                    ellipsis: true,
                    width: 220,
                    render: (text, record, index) => {
                        let sysConfig = JSON.parse(this.sysConfig);
                        const securityType = sysConfig ? sysConfig.map(item => ({key: item.key, name: item.name})) : [];
                        let typeArr = record?.securityTypeList.map(key => {
                            return {
                                key: key.trim(),
                                name: securityType.find(item => item.key === key)?.name?.trim().slice(0, 2)
                            }
                        }) || [];
                        return <div style={{display: "flex", flexWrap: "wrap"}}>
                            {text ? typeArr.map((item, index) => {
                                return <div key={index} style={{
                                    width: 40,
                                    height: 22,
                                    borderRadius: 4,
                                    border: "1px solid #ffadd2",
                                    backgroundColor: "#fff0f6",
                                    color: getColorBySecurityType(item?.key),
                                    fontSize: 12,
                                    textAlign: "center",
                                    marginRight: 5,
                                }}>{item?.name}</div>
                            }) : ''}
                        </div>
                    }
                },
                {
                    title: "风险数量",
                    dataIndex: "securityAllCount",
                    key: "securityAllCount",
                    ellipsis: true,
                    width: 100,
                    render: (text, record, index) => {
                        let color = "#F56C6C";
                        if (record.securityProcessedCount === 0) {
                            color = "#89D069";
                        }
                        return <div><span
                            style={{color: color}}>{record.securityProcessedCount}</span>/<span>{text}</span>
                        </div>
                    }
                },
                {
                    title: "检测时间",
                    dataIndex: "checkTime",
                    key: "checkTime",
                    ellipsis: true,
                    width: 150,
                    render: (text, record, index) => {
                        return <div>{text ? formatTime(text) : ''}</div>
                    }
                },
                {
                    title: "主责单位",
                    dataIndex: "mainDeptName",
                    key: "mainDeptName",
                    ellipsis: true,
                    width: 200,
                },
                {
                    title: "负责人",
                    dataIndex: "leader",
                    key: "leader",
                    ellipsis: true,
                    width: 200,
                },
            ]
        )
    }

    getOperate() {
        return {
            title: "操作",
            dataIndex: "operation",
            key: "operation",
            width: 300,
            fixed: "right",
            render: (text, record) => {
                return (
                    <>
                        {this.renderPmsActionButton(record)}
                    </>
                );
            }
        }
    }

    renderPmsActionButton(record) {
        let pmsListBtnList=getPmsListBtn
        if (typeof CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.PMS_LIST_BTN === 'function') {
            pmsListBtnList=CUSTOM_CONFIG?.CUSTOM_CONTENT_SAFETY?.PMS_LIST_BTN(getPmsListBtn)
        }
        return pmsListBtnList.map((item, index) => {
            return this.renderButton(record, item)
        })
    }

    renderButton(record, item) {
        if (item.showFun && typeof item.showFun === "function" && !item.showFun(record, item, this)) return null;
        let type = item.type;
        let component = item.component;
        let Component = null;
        switch (type) {
            case 1:
                Component = component;
                return Component
            case 2:
                try {
                    Component = require(`./components/btnType/${component}/${component}`).default;
                } catch (e) {
                    console.log(e.toString())
                }
                if (Component) {
                    return <Component
                        {
                            ...item
                        }
                        record={record}
                        that={this}
                        onClick={() => item.onClick(record, item, this)}
                    />
                }
                break;
        }
    }

    getHeaderColumns() {
        let {listData, batchRemindStatus, batchIgnoreStatus} = this.state;
        let canCheckList = [];
        let disabledAll = false;

        if (batchRemindStatus) {
            canCheckList = listData.filter(item => item.disposeStatus === 1 || item.disposeStatus === 4)
        }
        if (batchIgnoreStatus) {
            canCheckList = listData.filter(item => item.disposeStatus === 1)
        }
        if (!canCheckList?.length) {
            disabledAll = true
        }
        return {
            title: (() => {
                let checkedAll = canCheckList.length ? canCheckList.every(item => item.checked) : false;
                let checkedLength = canCheckList.length ? canCheckList.filter(item => item.checked).length : 0
                let indeterminate = canCheckList.length && checkedLength > 0 && checkedLength < canCheckList.length;
                return (
                    <Checkbox checked={checkedAll} disabled={disabledAll} indeterminate={indeterminate}
                              onChange={(e) => {
                                  this.state.listData.forEach(item => {
                                      if (batchRemindStatus && (item.disposeStatus === 1 || item.disposeStatus === 4)) {
                                          item.checked = e.target.checked;
                                      }
                                      if (batchIgnoreStatus && item.disposeStatus === 1) {
                                          item.checked = e.target.checked;
                                      }
                                  });
                                  this.setState({})
                              }}/>
                )
            })(),
            align: 'center',
            width: 50,
            key: "checked",
            render: (record) => {
                let disabled = false;
                if (batchRemindStatus && record.disposeStatus !== 1 && record.disposeStatus !== 4) {
                    disabled = true;
                }
                if (batchIgnoreStatus && record.disposeStatus !== 1) {
                    disabled = true;
                }
                return (
                    <div>
                        <Checkbox disabled={disabled} checked={record.checked} onChange={() => {
                            record.checked = !record.checked;
                            this.setState({})
                        }}/>
                    </div>
                )
            }
        }
    }

    tabsHeight = 55;
    pageMargin = 15;
    searchHeight = 0;
    screenHeight = 56;
    paginationHeight = 72;
    topMenuHeight = 70; //顶部菜单高度
    extraHeight = 50;

    renderTable() {
        const tableHeight = this.calculateTableHeight(this.searchHeight);
        const {listData, tabKey = "safetyManageTable", batchIgnoreStatus, batchRemindStatus} = this.state;
        const columns = this.getColumns();
        if (batchIgnoreStatus || batchRemindStatus) columns.unshift(this.getHeaderColumns());
        columns.push(this.getOperate());
        let scrollX = this.getScrollX(columns);
        let scrollY = this.getScrollY(tableHeight, listData);
        return (
            <>
                <TableTemplate
                    columns={columns}
                    dataSource={listData}
                    scroll={{ ...scrollX,...scrollY}}
                    onResize={(offsetHeight) => {
                    }}
                />
            </>
        )
    }

    thisPageMargin = 30;
    thisPagePadding = 64;
    // 如果当前表格宽度大于最大宽度，则中间需要滚动，否则不需要滚动
    getScrollX = (columns, defaultItemWidth = 100) => {
        let scrollX = {};
        let maxWidth = getMaxWidth(this.thisPageMargin + this.thisPagePadding);
        let columnsWidth = this.getColumnsWidth(columns, defaultItemWidth) || 0;
        if (columnsWidth > maxWidth) {
            scrollX.x = columnsWidth
        }
        return scrollX
    };

    getScrollY = (maxHeight, dataSource) => {
        let scrollY = {};
        if (dataSource?.length) {
            scrollY.y = maxHeight
        }
        return scrollY
    };

    getColumnsWidth = (columns, defaultItemWidth) => {
        let columnsWidth = 0;
        if (columns?.length) {
            columns.forEach(column => {
                if (column?.width) {
                    columnsWidth += column.width
                } else {
                    columnsWidth += defaultItemWidth
                }
            })
        }
        return columnsWidth
    };

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = ({current, pageSize}) => {
        this.state.params.page = current;
        this.state.params.size = pageSize;
        this.setState({}, () => {
            this.getListData();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = ({current, pageSize}) => {
        this.state.params.page = 1;
        this.state.params.size = pageSize;
        this.setState({}, () => {
            this.getListData();
        });
    };

    renderPagination() {
        let {page, size} = this.state.params;
        let {listData, tabKey = "safetyManagePagination", count} = this.state;
        if (!count) {
            return
        }
        return (
            <PaginationTemplate
                // key={"PageTemplate" + tabKey}
                total={count || 0}
                pageSize={size || 10}
                current={page || 1}
                dataSource={listData}
                onShowSizeChange={this.onShowSizeChange}
                onChange={this.onPageChange}
                onResize={(offsetHeight) => {
                    if (this.paginationHeight != offsetHeight) {
                        this.paginationHeight = offsetHeight;
                        this.setState({});
                    }
                }}
            />
        )
    }

    renderDetail() {
        return (
            <Detail ref={ref => this.detail = ref} refreshList={() => this.getListData()}
                    typeData={this.state.typeData}/>
        )
    }

    renderRemarks() {
        return (
            <Remark ref={ref => this.remark = ref}/>
        )
    }

    render() {
        return (
            <>
                {this.renderTabs()}
                <PageTemplate styleOut={{margin: "0 15px 15px 15px"}} style={{borderRadius: "0 0 5px 5px"}}>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        {this.renderOperate()}
                        {this.renderMore()}
                    </div>
                    {this.state.moreScreen ? this.renderSearch() : null}
                    {this.renderTable()}
                    {this.renderPagination()}
                </PageTemplate>
                {this.renderDetail()}
                {this.renderRemarks()}
                {/*查看内容*/}
                <Preview ref={ref => this.preview = ref} typeData={this.state.typeData}/>
            </>
        )
    }
}